(ns ycweb.components.headings
  (:require
   [rum.core :as rum]
   [ycweb.components.buttons :as buttons]
   [ycweb.util.core :as u]))

;;TODO: Icons need to be implemented

(rum/defc heading < rum/reactive
  [text
   {:keys [type size id class center flush
           pretext subtext custom_attrs
           icon icon_placement dangerouslySetInnerHTML?]
    :as options}]

  (let [inner-classes
        (u/bem :yc-heading
          [(when center :center)
           (when flush :flush)
           (if size size :medium)])
        custom-classes
        (when class [class])

        classes
        {:class
         (concat inner-classes custom-classes)}
        attrs
        (u/maybe assoc
          (or custom_attrs {})
          :id id)
        tag (or (#{:h1 :h2 :h3 :h4 :h5} type) :h2)
        children
        (cond-> []
          icon
          (conj
            (buttons/button-icon
              {:icon icon :icon-display :inline :icon-class "icon--in-copy-left"}))

          (and pretext dangerouslySetInnerHTML?)
          (conj [:span.hidden-from-view "–"]
            [:span.yc-heading__pretext {:dangerouslySetInnerHTML {:__html pretext}}])

          (and pretext (not dangerouslySetInnerHTML?))
          (conj [:span.yc-heading__pretext pretext]
            [:span.hidden-from-view "–"])

          (and dangerouslySetInnerHTML? (u/presence text))
          (conj [:span {:dangerouslySetInnerHTML {:__html text}}])

          (and (not dangerouslySetInnerHTML?) text)
          (conj text)

          (and subtext dangerouslySetInnerHTML?)
          (conj [:span.hidden-from-view "–"]
            [:span.yc-heading__subtext {:dangerouslySetInnerHTML {:__html subtext}}])

          (and subtext (not dangerouslySetInnerHTML?))
          (conj [:span.hidden-from-view "–"]
            [:span.yc-heading__subtext subtext]))]
    (into [tag (merge classes attrs)] children)))